(function () {
  'use strict';

  // Carousel
  // ----------------------------------------
  var carousel = $( '.carousel' );
  var carouselElements = carousel.find( '.carousel-elements > div' );
  var carouselButtons = carousel.find( '.carousel-buttons' ).removeClass( 'hidden' );

  var nextButton = carouselButtons.find( 'button.btn-next' );
  var backButton = carouselButtons.find( 'button.btn-back' );

  var start, end, indent;
  var windowWith;

  initCarousel();

  nextButton.bind( 'click', function(e) {
    e.preventDefault();

    if ( !$( this ).hasClass( 'disabled' ) ) {
      toggleElements(start = start + indent, end = end + indent);

      if (end >= carouselElements.find( '> div' ).length) {
        nextButton.addClass( 'disabled' );
      }
  
      backButton.removeClass( 'disabled' );
    }
  });
 
  backButton.bind( 'click', function(e) {
    e.preventDefault();

    if ( !$( this ).hasClass( 'disabled' ) ) {    
      toggleElements(start = start - indent, end = end - indent);
  
      if (start == 1) {
        backButton.addClass( 'disabled' );
      }
  
      nextButton.removeClass( 'disabled' );
    }
  });

  function initCarousel() {
    var visibleElements = carouselElements.find( '> div:visible' ).length;
    
    start = 1;
    end = visibleElements;
    indent = visibleElements;

    windowWith = $( window ).width();

    var maxHeight = Math.max.apply(null, carouselElements.find( '> div' ).map(function () {
      return $( this ).outerHeight();
    }).get());

    $( '.carousel-elements' ).css( 'min-height', maxHeight + 75 );
  };

  function toggleElements(start, end) {
    carouselElements.find( '> div' ).hide();
    carouselElements.find( '> div:nth-child(n+' + start + '):nth-child(-n+' + end + ')' ).show();
  };

  $( window ).on( 'resize', function() {
    if($( window ).width() !== windowWith) {
      carouselElements.find( '> div' ).removeAttr( 'style' );
    
      backButton.addClass( 'disabled' );
      nextButton.removeClass( 'disabled' );
  
      initCarousel();
    }
  } );
})();
